import { render, staticRenderFns } from "./footerMoudle.vue?vue&type=template&id=9d1f5db6&scoped=true"
import script from "./footerMoudle.vue?vue&type=script&lang=js"
export * from "./footerMoudle.vue?vue&type=script&lang=js"
import style0 from "./footerMoudle.vue?vue&type=style&index=0&id=9d1f5db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1f5db6",
  null
  
)

export default component.exports